import { z } from 'zod';

export const useRegisterUserForm = () => {
	const schema = z
		.object({
			email: z.string().email(),
			firstName: z.string().min(1),
			lastName: z.string().min(1),
			city: z.string().min(1),
			zipCode: z.string().min(1),
			country: z.string().min(1),
			password: z.string().min(1),
			confirmPassword: z.string().min(1),
			phoneNumber: z.string().min(1),
			mentorId: z.number().min(1),
			placementPartnerId: z.number().min(1),
			placement: z.number().min(1),
		})
		.refine(data => data.password === data.confirmPassword, { message: 'Passwords do not match', path: ['confirmPassword'] });

	return {
		schema,
	};
};
